// src/components/Footer.jsx
import React from 'react';
import {
  Box,
  Typography,
  Container,
  Grid,
  List,
  ListItem,
  ListItemText,
  Link,
  ListItemIcon

} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';



function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    // MAIN WRAPPER: This Box spans the full page width with primary color
    <Box sx={{
      width: '100%',
      backgroundColor: 'var(--primary-color)',
      mt: 'auto',
    }}>
      <Container maxWidth="lg" sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}>

        <Grid container justifyContent="center" sx={{
          py: 3,
          //borderBottom: 1,
          //borderColor: 'divider',
          width: '100%',
          //mb: 2,
        }}>
          <Grid item xs={12}>
            <Grid container spacing={4} justifyContent="center">

              {/* About TerViTus - updated note */}

              <Grid item xs={12} sm={12} md={6}>
                <Typography variant="h6" gutterBottom sx={{ color: 'common.white' }}>
                  Noor-un-Nikah: Sacred Bonds, Divine Purpose.
                </Typography>
                <Typography variant="body2" sx={{
                  color: 'common.white',
                  mb: 1,
                  pl: 2, // Padding left for indentation
                  textAlign: 'justify'
                }}>
                  A <strong>Carvan-e-Islam</strong> initiative for <strong>meaningful</strong>, <strong>halal matrimonial</strong> connections, helping individuals find <strong>compatible</strong>, <strong>value-aligned partners</strong>.
                </Typography>
                <Typography variant="body2" sx={{
                  color: 'common.white',
                  mb: 1,
                  pl: 2, // Padding left for indentation
                  textAlign: 'justify'
                }}>
                  With <strong>respect</strong>, <strong>modesty</strong>, and <strong>integrity</strong> at its core, every connection is formed with <strong>divine intention</strong>.
                </Typography>
                <Typography variant="body2" sx={{
                  color: 'common.white',
                  pl: 2, // Padding left for indentation
                  textAlign: 'justify'
                }}>
                  Choose <strong>Noor-un-Nikah</strong> for a <strong>blessed marriage</strong>, where <strong>faith</strong>, <strong>purpose</strong>, and compatibility come together to create <strong>lifelong harmony</strong>.
                </Typography>
              </Grid>

              {/* Customer Service */}
              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="h6" gutterBottom sx={{ color: 'common.white' }}>
                  Customer Service
                </Typography>
                <List dense>
                  <ListItem>
                    <ListItemText
                      primary={
                        <Link
                          component={RouterLink}
                          to="/profile-input"
                          className="white-link"
                          sx={{
                            textDecoration: 'none',
                            '&:hover': {
                              color: 'var(--accent-color)',
                            }
                          }}
                        >
                          Add Your Profile
                        </Link>
                      }
                      sx={{
                        color: 'common.white',
                        '& .MuiTypography-root': {
                          color: 'common.white',
                        }
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={
                        <Link
                          component={RouterLink}
                          to="/profiles"
                          className="white-link"
                          sx={{
                            textDecoration: 'none',
                            '&:hover': {
                              color: 'var(--accent-color)',
                            }
                          }}
                        >
                          Find Profile
                        </Link>
                      }
                      sx={{
                        color: 'common.white',
                        '& .MuiTypography-root': {
                          color: 'common.white',
                        }
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={
                        <Link
                          component={RouterLink}
                          to="/faqs"
                          className="white-link"
                          sx={{
                            textDecoration: 'none',
                            '&:hover': {
                              color: 'var(--accent-color)',
                            }
                          }}
                        >
                          FAQs
                        </Link>
                      }
                      sx={{
                        color: 'common.white',
                        '& .MuiTypography-root': {
                          color: 'common.white',
                        }
                      }}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      primary={
                        <Link
                          component={RouterLink}
                          to="/contact-us"
                          className="white-link"
                          sx={{
                            textDecoration: 'none',
                            '&:hover': {
                              color: 'var(--accent-color)',
                            }
                          }}
                        >
                          Contact Us
                        </Link>
                      }
                      sx={{
                        color: 'common.white',
                        '& .MuiTypography-root': {
                          color: 'common.white',
                        }
                      }}
                    />
                  </ListItem>
                </List>
              </Grid>

              {/* Contact Info */}
              <Grid item xs={12} sm={6} md={3}>
                <Typography variant="h6" gutterBottom sx={{ color: 'common.white' }}>
                  Get in Touch
                </Typography>
                <List dense>

                  {/* Email */}
                  <ListItem>
                    <ListItemIcon sx={{ color: 'common.white', minWidth: 36 }}>
                      <EmailIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Link
                          href="mailto:support@tervitus.com"
                          className="white-link"
                          sx={{
                            textDecoration: 'none',
                            color: 'common.white',
                            '&:hover': { color: 'var(--accent-color)' },
                          }}
                        >
                          support@noorunnikah.com
                        </Link>
                      }
                    />
                  </ListItem>

                  {/* Phone */}
                  <ListItem>
                    <ListItemIcon sx={{ color: 'common.white', minWidth: 36 }}>
                      <PhoneIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Link
                          href="tel:+923425262121"
                          className="white-link"
                          sx={{
                            textDecoration: 'none',
                            color: 'common.white',
                            '&:hover': { color: 'var(--accent-color)' },
                          }}
                        >
                          +92 34 2526 2121
                        </Link>
                      }
                    />
                  </ListItem>

                  {/* Location */}
                  <ListItem>
                    <ListItemIcon sx={{ color: 'common.white', minWidth: 36 }}>
                      <LocationOnIcon />
                    </ListItemIcon>
                    <ListItemText
                      primary="Lahore, Pakistan"
                      sx={{
                        color: 'common.white',
                        '& .MuiTypography-root': { color: 'common.white' },
                      }}
                    />
                  </ListItem>

                </List>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Footer Content Box */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            backgroundColor: "var(--secondary-color)",
            p: 0.5,
            borderRadius: "10px 10px 0 0",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Box
            component="footer"
            sx={{
              px: 2,
              py: 1,
              width: '100%',
            }}
          >
            {/* Updated Grid for mobile responsiveness */}
            <Grid container alignItems="center">
              {/* Copyright - full width on mobile, half on desktop */}
              <Grid item xs={12} sm={6}>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'text.primary',
                    textAlign: { xs: 'center', sm: 'left' },
                    mb: { xs: 1, sm: 0 }
                  }}
                >
                  &copy; {currentYear} <strong>Noor-un-Nikah</strong>— A <strong>Carvan-e-Islam</strong> Initiative. All rights reserved.
                </Typography>
              </Grid>

              {/* Powered by - full width on mobile, half on desktop */}
              <Grid item xs={12} sm={6}>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'text.primary',
                    textAlign: { xs: 'center', sm: 'right' }
                  }}
                >
                  Powered by: {' '}
                  <Link
                    href="https://www.whizdot.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                      textDecoration: 'none',
                      color: 'primary.main',
                      '&:hover': {
                        color: 'var(--accent-color)',
                      }
                    }}
                  >
                    <strong>WhizDot</strong>
                  </Link>
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>
        {/* Footer Content Box End */}

      </Container>
    </Box>
  );
}

export default Footer;